import { useEffect, useState } from 'react';

interface Return {
  targetsWidth: number;
}
export const useTargetsDomWidth = (elementByIds: string[]): Return => {
  const [targetsWidth, setTargetsWidth] = useState<number>(0);

  useEffect(() => {
    let totalWidth = 0;
    elementByIds.forEach((elementById) => {
      totalWidth += document.getElementById(elementById)?.offsetWidth ?? 0;
    });

    setTargetsWidth(totalWidth);
  }, [elementByIds]);

  return { targetsWidth };
};
